export default __webpack_public_path__ + "static/media/rs-arte-13.0c44c350.webp";